import React from "react";
import styled from "styled-components";
import CommonModal from "../based/Modal";

function VideoModal({ show, onClose, videoUrl }) {
    const isVideo = videoUrl && videoUrl.endsWith(".mp4");
    return (
        <CommonModal show={show} onClose={onClose} size="md" title="Video">
            <Wrapper>{isVideo ? <video src={videoUrl} controls></video> : <img src={videoUrl} alt="" />}</Wrapper>
        </CommonModal>
    );
}

export default VideoModal;

const Wrapper = styled.div`
    .thumbnail .icon {
        display: flex;
        position: absolute;
        top: calc(50px - 12px);
        left: calc(50px - 12px);
    }

    .thumbnail {
        position: relative;
    }

    video {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
`;
